var _path, _path2, _path3, _path4, _path5, _path6, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g2, _rect9, _rect0, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path7, _path8, _circle8, _circle9, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 930,
    height: 377,
    viewBox: "0 0 930 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.715 186.622L197.833 142.009C197.515 141.535 196.981 141.25 196.41 141.25H180.631",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.295 190.904L274.872 250.328C274.551 250.649 274.115 250.829 273.661 250.829H178.919",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.686 82.1809L390.35 22.8604C390.621 22.2338 391.238 21.8281 391.921 21.8281H417.762",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M364.686 294.487L390.35 353.808C390.621 354.434 391.238 354.84 391.921 354.84H417.762",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.488 82.1809L268.825 22.8604C268.554 22.2338 267.936 21.8281 267.253 21.8281H241.412",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.488 294.487L268.825 353.808C268.554 354.434 267.936 354.84 267.253 354.84H241.412",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6442_23571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.739 86.0013H472.45C475.23 86.0013 477.484 83.7472 477.484 80.9665V79.5134C477.484 76.7327 479.739 74.4785 482.519 74.4785H555.886C558.653 74.4785 560.902 76.7119 560.92 79.4792L562.397 297.319C562.416 300.113 560.156 302.388 557.362 302.388H482.519C479.739 302.388 477.484 300.134 477.484 297.353V294.949C477.484 292.168 475.23 289.914 472.45 289.914H251.615C249.77 289.914 248.07 288.915 247.225 287.275C217.638 229.86 222.605 141.109 247.27 88.7909C248.084 87.0628 249.829 86.0013 251.739 86.0013Z",
    stroke: "url(#paint0_linear_6442_23571)",
    strokeWidth: 7.51427
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 552.932,
    y: 98.7305,
    width: 12.7405,
    height: 179.567,
    rx: 3.03707,
    fill: "url(#paint1_linear_6442_23571)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 80.3848,
    width: 15.1045,
    height: 10.0697,
    fill: "#A4CA4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 575.106,
    y: 83.1445,
    width: 141.983,
    height: 5.03484,
    rx: 2.51742,
    fill: "url(#paint2_linear_6442_23571)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 574.889,
    y: 130.385,
    width: 15.1045,
    height: 10.0697,
    fill: "#A4CA4E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 574.995,
    y: 133.145,
    width: 141.983,
    height: 5.03484,
    rx: 2.51742,
    fill: "url(#paint3_linear_6442_23571)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 572.889,
    y: 286.385,
    width: 15.1045,
    height: 10.0697,
    fill: "#A4CA4E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 572.995,
    y: 289.145,
    width: 141.983,
    height: 5.03484,
    rx: 2.51742,
    fill: "url(#paint4_linear_6442_23571)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 565.672,
    y: 79.6035,
    width: 12.7405,
    height: 217.606,
    rx: 3.03707,
    fill: "url(#paint5_linear_6442_23571)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6442_23571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4727,
    height: 210.4,
    transform: "translate(429.386 83.0176)",
    fill: "url(#paint6_linear_6442_23571)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.122,
    cy: 123.177,
    r: 9.25358,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.122,
    cy: 155.699,
    r: 9.25358,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.122,
    cy: 188.218,
    r: 9.25358,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.122,
    cy: 220.738,
    r: 9.25358,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.122,
    cy: 253.259,
    r: 9.25358,
    fill: "white"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 574.889,
    y: 241.385,
    width: 15.1045,
    height: 10.0697,
    fill: "#A4CA4E"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 574.995,
    y: 244.145,
    width: 141.983,
    height: 5.03484,
    rx: 2.51742,
    fill: "url(#paint7_linear_6442_23571)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 294.488,
    cy: 85.6064,
    r: 6.84854,
    fill: "#65727D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.84854,
    cy: 6.84854,
    r: 6.84854,
    transform: "matrix(1 0 0 -1 287.64 297.912)",
    fill: "#65727D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.685,
    cy: 85.6064,
    r: 6.84854,
    fill: "#65727D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.012,
    cy: 188.335,
    r: 6.84854,
    fill: "#65727D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.02,
    cy: 199.464,
    r: 6.84854,
    fill: "#65727D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.538,
    cy: 291.919,
    r: 6.84854,
    fill: "#65727D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.703,
    cy: 185.767,
    r: 6.84854,
    fill: "#65727D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M584.695 182.342L618.073 159.527C618.357 159.333 618.694 159.229 619.039 159.229H745.636",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M558.585 202.887L594.508 230.357C594.807 230.585 595.172 230.709 595.548 230.709H735.363",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.859,
    cy: 188.335,
    r: 6.84854,
    fill: "#65727D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.84854,
    cy: 6.84854,
    r: 6.84854,
    transform: "matrix(1 0 0 -1 357.837 297.912)",
    fill: "#65727D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M714.817 297.055L767.812 354.714C768.137 355.067 768.594 355.267 769.073 355.267H794.003",
    stroke: "#85929F",
    strokeWidth: 0.856068
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6442_23571",
    x: 223.103,
    y: 70.7207,
    width: 345.784,
    height: 238.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.73246,
    dy: 2.73246
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.43386 0 0 0 0 0.511271 0 0 0 0 0.253991 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6442_23571"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6442_23571",
    x: 429.386,
    y: 83.0176,
    width: 35.522,
    height: 213.133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.04935,
    dy: 2.73246
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07402
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.911754 0 0 0 0 1 0 0 0 0 0.717613 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6442_23571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6442_23571",
    x1: 213.864,
    y1: 196.073,
    x2: 716.637,
    y2: 190.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7AA31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    stopColor: "#98CA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6442_23571",
    x1: 548.591,
    y1: 192.823,
    x2: 572.5,
    y2: 194.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6442_23571",
    x1: 575.106,
    y1: 85.662,
    x2: 717.089,
    y2: 85.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6442_23571",
    x1: 574.995,
    y1: 135.662,
    x2: 716.978,
    y2: 135.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6442_23571",
    x1: 572.995,
    y1: 291.662,
    x2: 714.978,
    y2: 291.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6442_23571",
    x1: 563.278,
    y1: 200.609,
    x2: 585.821,
    y2: 201.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6442_23571",
    x1: -4.16525,
    y1: 114.03,
    x2: 33.6572,
    y2: 114.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6442_23571",
    x1: 574.995,
    y1: 246.662,
    x2: 716.978,
    y2: 246.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516427"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFork);
export default __webpack_public_path__ + "static/media/openFork.9a6d8008c5db5a658b2665106fda2555.svg";
export { ForwardRef as ReactComponent };